package com.vizio.redwolf.dms.model

import kotlinx.serialization.Serializable

@Serializable
class RegisterDeviceRequestRequestBody(
    val deviceId: String,
    val deviceInstanceId: String,
    val friendlyName: String,
    val modelName: String,
    val serialNumber: String,
    val skipUniqueDeviceCheck: Boolean,
    val skipCreditCard: Boolean? = null,
    val launchSource: String? = null
)
